import { createElementBlock as n, openBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function l(a, e) {
  return t(), n("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "m18.71 16.295-6.6-13.2a1.8 1.8 0 0 0-3.22 0l-6.6 13.2A1.8 1.8 0 0 0 3.9 18.9h13.2a1.8 1.8 0 0 0 1.61-2.605M9.6 8.1a.9.9 0 1 1 1.8 0v3.6a.9.9 0 0 1-1.8 0zm.9 8.4a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
